export default __webpack_public_path__ + "static/media/43.7cc67ba8.jpg";